import { useEffect, useRef } from 'react'

import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useV2GenerationStatus } from 'hooks/calendar/useV2GenerationStatus'
import { useGenerationCompleteNotification } from './useGenerationCompleteNotification'

const FALSE_HYSTERESIS_MS = 1500

export const useV2GenerationChime = () => {
  const calendarV2 = useFlipperFlag('calendar_v2')
  const { notify } = useGenerationCompleteNotification()
  const { isActive } = useV2GenerationStatus(calendarV2)

  const wasActiveRef = useRef(false)

  useEffect(() => {
    if (!calendarV2) return
    if (isActive) {
      wasActiveRef.current = true
      return
    }
    if (!wasActiveRef.current) return

    const timer = setTimeout(() => {
      wasActiveRef.current = false
      notify()
    }, FALSE_HYSTERESIS_MS)
    return () => clearTimeout(timer)
  }, [calendarV2, isActive, notify])
}
